import * as  echarts from 'echarts/lib/echarts';
import 'echarts/lib/component/grid';
import React, { useEffect, useRef, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import useWindowDimensions from '../hook/useWindowDimensions';

const mockData = { "chg1": 0.56, "chg5": 2.35, "chg20": 7.99, "chg60": 8.48, "chg120": 21.15, "chg250": 39.12, "priceData": "{\"2021-10-25\": {\"Open\": 375.56, \"Close\": 377.93, \"High\": 378.87, \"Low\": 373.56, \"SumScore\": 98.33333333333333, \"%Chg\": 1.02, \"Chg\": 3.83, \"Volume\": 32597800}, \"2021-10-26\": {\"Open\": 380.23, \"Close\": 379.12, \"High\": 382.71, \"Low\": 377.91, \"SumScore\": 98.33333333333333, \"%Chg\": 0.31, \"Chg\": 1.19, \"Volume\": 47191300}, \"2021-10-27\": {\"Open\": 379.58, \"Close\": 380.0, \"High\": 383.15, \"Low\": 379.31, \"SumScore\": 98.33333333333333, \"%Chg\": 0.23, \"Chg\": 0.88, \"Volume\": 45760500}, \"2021-10-28\": {\"Open\": 381.95, \"Close\": 384.22, \"High\": 384.48, \"Low\": 381.16, \"SumScore\": 98.33333333333333, \"%Chg\": 1.11, \"Chg\": 4.22, \"Volume\": 38007000}, \"2021-10-29\": {\"Open\": 381.06, \"Close\": 386.11, \"High\": 386.28, \"Low\": 380.7, \"SumScore\": 98.33333333333333, \"%Chg\": 0.49, \"Chg\": 1.89, \"Volume\": 37225600}, \"2021-11-01\": {\"Open\": 386.56, \"Close\": 387.43, \"High\": 387.56, \"Low\": 384.42, \"SumScore\": 98.33333333333333, \"%Chg\": 0.34, \"Chg\": 1.32, \"Volume\": 30765300}, \"2021-11-02\": {\"Open\": 386.8, \"Close\": 389.05, \"High\": 389.54, \"Low\": 386.75, \"SumScore\": 100.0, \"%Chg\": 0.42, \"Chg\": 1.62, \"Volume\": 25135300}, \"2021-11-03\": {\"Open\": 389.55, \"Close\": 393.18, \"High\": 393.61, \"Low\": 388.48, \"SumScore\": 100.0, \"%Chg\": 1.06, \"Chg\": 4.13, \"Volume\": 33748900}, \"2021-11-04\": {\"Open\": 394.48, \"Close\": 398.22, \"High\": 399.2, \"Low\": 393.92, \"SumScore\": 100.0, \"%Chg\": 1.28, \"Chg\": 5.04, \"Volume\": 40265300}, \"2021-11-05\": {\"Open\": 400.04, \"Close\": 398.6, \"High\": 400.99, \"Low\": 397.16, \"SumScore\": 100.0, \"%Chg\": 0.1, \"Chg\": 0.38, \"Volume\": 43341700}, \"2021-11-08\": {\"Open\": 398.57, \"Close\": 398.06, \"High\": 399.62, \"Low\": 397.4, \"SumScore\": 100.0, \"%Chg\": -0.14, \"Chg\": -0.54, \"Volume\": 29256300}, \"2021-11-09\": {\"Open\": 399.16, \"Close\": 395.32, \"High\": 399.57, \"Low\": 393.92, \"SumScore\": 100.0, \"%Chg\": -0.69, \"Chg\": -2.74, \"Volume\": 50490700}, \"2021-11-10\": {\"Open\": 392.47, \"Close\": 389.51, \"High\": 395.36, \"Low\": 387.53, \"SumScore\": 100.0, \"%Chg\": -1.47, \"Chg\": -5.81, \"Volume\": 54937400}, \"2021-11-11\": {\"Open\": 392.57, \"Close\": 390.59, \"High\": 392.75, \"Low\": 390.24, \"SumScore\": 100.0, \"%Chg\": 0.28, \"Chg\": 1.08, \"Volume\": 32243000}, \"2021-11-12\": {\"Open\": 391.77, \"Close\": 394.7, \"High\": 395.25, \"Low\": 390.13, \"SumScore\": 100.0, \"%Chg\": 1.05, \"Chg\": 4.11, \"Volume\": 34669800}, \"2021-11-15\": {\"Open\": 395.91, \"Close\": 394.61, \"High\": 396.24, \"Low\": 392.1, \"SumScore\": 100.0, \"%Chg\": -0.02, \"Chg\": -0.09, \"Volume\": 33716900}, \"2021-11-16\": {\"Open\": 393.86, \"Close\": 397.42, \"High\": 397.93, \"Low\": 393.66, \"SumScore\": 100.0, \"%Chg\": 0.71, \"Chg\": 2.81, \"Volume\": 27872900}, \"2021-11-17\": {\"Open\": 397.75, \"Close\": 397.63, \"High\": 399.72, \"Low\": 396.64, \"SumScore\": 100.0, \"%Chg\": 0.05, \"Chg\": 0.21, \"Volume\": 28703300}, \"2021-11-18\": {\"Open\": 399.73, \"Close\": 401.75, \"High\": 402.27, \"Low\": 397.45, \"SumScore\": 100.0, \"%Chg\": 1.04, \"Chg\": 4.12, \"Volume\": 45721500}, \"2021-11-19\": {\"Open\": 403.43, \"Close\": 403.99, \"High\": 405.3, \"Low\": 402.58, \"SumScore\": 100.0, \"%Chg\": 0.56, \"Chg\": 2.24, \"Volume\": 45138700}}" }
var label;
var colorList = ["#000000", "#FF0000", "#FF5B00", "#FF8700", "#FFAD00", "#FFD000", "#FFE000", "#EAEF00", "#DBFF00", "#4CB200", "#008000"]
export default function StockKChart(prop) {

    const { height, width } = useWindowDimensions();
    let chartId = uuidv4() + prop.label;
    var myChart;
    let style = {
        container: {
            display: "flex",
            padding: "5px",
            margin: "5px",
        },
        label: {
            flex: 2,
            margin: "2px",
            fontSize: "2.5vw",
            "textAlign": "center",
            "alignSelf": "center",
            color: "#FF0000"
        },
        chg: {
            flex: 1,
            margin: "2px",
            fontSize: "2.5vw",
            "textAlign": "center",
            "alignSelf": "center"
        },
        chart: {
            "alignSelf": "center",
            margin: "2px",
            width: "50vw",
            height: "10vh",
        }

    }

    const [myData, setMyData] = useState();
    const [lastPrice, setLastPrice] = useState(0);
    const [chg1, setChg1] = useState(0);
    const [chg5, setChg5] = useState(0);
    const [chg20, setChg20] = useState(0);
    const [chg120, setChg120] = useState(0);
    const [chg250, setChg250] = useState(0);
    const [lastSumScore, setLastSumScore] = useState(0);
    useEffect(() => { init() }, []);
    useEffect(resizeChart);
    useEffect(buildData(), [myData]);

    return (
        <section id={chartId + 'section'}>
            <div style={style.container}>
                <div style={assignLabelStyle(lastSumScore)} >{prop.label}</div>
                <div style={assignChgStyle(chg1)}>{lastPrice}</div>
                <div style={assignChgStyle(chg1)}>{chg1}</div>
                <div style={assignChgStyle(chg5)}>{chg5}</div>
                <div style={assignChgStyle(chg20)}>{chg20}</div>
                <div id={chartId} style={style.chart}></div>
            </div>
        </section>
    );
    function buildData() {
        return () => {
            if (myData === undefined) {
                console.log('data is null')
                return;
            }
            let priceData = JSON.parse(myData.priceData)
            buildOption(priceData);
            buildLastSumScore(priceData)
            buildChgData(myData);
            buildLastPrice(myData)
        };
    }

    function resizeChart() {
        let chart = echarts.getInstanceByDom(document.getElementById(chartId));
        if (chart) {
            console.log('resize')
            chart.resize();
        }
    }
    function getMockData() {
        label = "QQQ";
        setMyData(mockData);
        buildOption(mockData);
        buildChgData(mockData);
    }

    function buildLastSumScore(priceData) {

        if (priceData === undefined) {
            console.log('price data is null')
            return;
        }

        let values = Object.values(priceData)
        setLastSumScore(values[values.length - 1]['SumScore'])
    }
    function buildLastPrice(data) {

        if (data === undefined) {
            console.log('data is null')
            return;
        }
        setLastPrice(data.lastPrice)
    }
    function buildChgData(data) {
        if (data === undefined) {
            console.log('data is null')
            return {};
        }
        setChg1(data.chg1)
        setChg5(data.chg5)
        setChg20(data.chg20)
        setChg120(data.chg120)
        setChg250(data.chg250)
    }
    function getData() {
        label = prop.label;
        if (prop.label === undefined) {
            return;
        }
        var url = 'https://4g6jaukaha.execute-api.eu-central-1.amazonaws.com/development/stock?label=' + prop.label;
        fetch(url, { mode: 'cors' })
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    return response.text().then(error => { throw new Error(error) });
                }
            })
            .then(data => {
                setMyData(data)
            })
            .catch(
                error => {
                    console.log('fetch error');
                    console.log(error);
                });
    }
    function getColorIndex(sumScore) {
        if (sumScore == 0) {
            return 0;
        }
        return Math.floor(sumScore)
    }
    function assignChgStyle(chg) {
        if (chg == 0) {
            return style.chg;
        }
        if (chg > 0) {
            return Object.assign({}, style.chg, { color: "green" })
        }
        if (chg < 0) {
            return Object.assign({}, style.chg, { color: "red" })
        }
    }
    function assignLabelStyle(SumScore) {
        let labelColor = colorList[getColorIndex(SumScore)];
        return Object.assign({}, style.label, { color: labelColor })
    }
    function init() {
        getData();
    }
    function buildOption(priceData) {

        if (priceData === undefined) {
            console.log('price data is null')
            return;
        }
        let dateList = []
        for (let date of Object.keys(priceData)) {
            dateList.push(date.substr(5));
        }
        let xData = {
            data: dateList,
            axisLabel: {
                rotate: 0, // 旋转30度
                show: true, //这行代码控制着坐标轴x轴的文字是否显示
            }
        }
        let values = Object.values(priceData)
        let stockDateList = []
        let minPrice = values[0]['Low'];
        let maxPrice = values[0]['High'];
        /*         let minVolume = values[0]['Volume'];
                let maxVolume = values[0]['Volume'];
                let volume = []; */
        for (let valueData of values) {
            let color = colorList[getColorIndex(valueData['SumScore'])];
            let valueObject = buildValueObject(valueData, color)
            stockDateList.push(valueObject);
            ({ minPrice, maxPrice } = updateMinMaxPrice(minPrice, valueData, maxPrice));
            /*             volume.push(valueData['Volume'] / million);
                        ({ minVolume, maxVolume } = updateMinMaxVolume(minVolume, valueData, maxVolume)); */
        }

        let yPriceAxisData = {
            show: false,
            min: minPrice > 10 ? Math.floor(minPrice / 10) * 10 : Math.floor(minPrice),
            max: maxPrice > 10 ? Math.ceil(maxPrice / 10) * 10 : Math.ceil(maxPrice)
        }
        let priceDataSeries = {
            type: 'candlestick',
            name: 'Price',
            data: stockDateList,
        }

        let option = {
            grid: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 0,
                borderWidth: 0,
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                },
                formatter: function (params) {
                    let open = params[0].value[1];
                    let close = params[0].value[2];
                    let chg = params[0].value[6];
                    let sumScore = params[0].value[5];
                    chg = chg.toFixed(2);
                    let chgRate = params[0].value[7];
                    chgRate = chgRate.toFixed(2);
                    let color = chg >= 0 ? "green" : "red";
                    if (chg == 0) {
                        color = "black";
                    }
                    return (
                        '<p style="color:' + color + '">' +
                        params[0].name
                        + '<br>close: ' + close
                        + '<br>chg: ' + chg
                        + '<br>chg%: ' + chgRate + "%"
                        + '<br>score: ' + sumScore
                        + ' </p>'
                    )
                }
            },
            animation: false,
            xAxis: xData,
            yAxis: [yPriceAxisData],
            series: [priceDataSeries]
        }
        initChart(option)
        return option;
    }

    function initChart(option) {
        myChart = echarts.init(document.getElementById(chartId));
        myChart.setOption(option, true);
    }
}


function buildValueObject(valueData, color) {
    return {
        value: [valueData['Open'], valueData['Close'], valueData['Low'], valueData['High'], valueData['SumScore'], valueData['Chg'], valueData['%Chg']],
        itemStyle: {
            color: color,
            color0: color,
            borderColor: color,
            borderColor0: color,
        }
    };
}

function updateMinMaxPrice(minPrice, valueData, maxPrice) {
    minPrice = valueData['Low'] < minPrice ? valueData['Low'] : minPrice;
    maxPrice = valueData['High'] > maxPrice ? valueData['High'] : maxPrice;
    return { minPrice, maxPrice };
}
